<script>
  import { getContext, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
  import { format } from 'svelte-i18n';
  import { Button } from '@sveltestrap/sveltestrap';

  const { context } = getContext('config');

  import CURRENT_VERSION from '@root/version.json';

  const REMOTE_VERSION_URL = 'https://assets.opensense.com/ui/latest/version.json';

  let showNotification = false;
  let exploded = false;
  let appIsEmbedded = context?.source;

  const checkVersion = async () => {
    try {
      const res = await fetch(REMOTE_VERSION_URL, { method: 'GET', cache: 'no-cache' });
      const data = await res.json();

      console.log('Version data:', data, CURRENT_VERSION);

      if (!showNotification && data?.version && data.version !== CURRENT_VERSION?.version) {
        showNotification = true;
      }
    } catch (err) {
      console.error('Version check failed:', err);
    }
  };

  const reloadPage = () => {
    exploded = true;
    setTimeout(() => location.reload(true), 200);
  };

  onMount(() => {
    if (appIsEmbedded) {
      return;
    }

    checkVersion();
    const interval = setInterval(checkVersion, 60 * 60 * 1000);
    return () => clearInterval(interval);
  });
</script>

{#if showNotification && !appIsEmbedded}
  <div class="notification" class:exploded transition:fly={{ y: 20, x: -10, opacity: 0, duration: 300 }}>
    {$format('label.NEW_UI_AVAILABLE')}
    <Button color="primary" size="sm" on:click={reloadPage}>{$format('label.RELOAD')}</Button>
  </div>
{/if}

<style lang="scss" src="./version-update.scss"></style>
